import React, { useState, useEffect } from 'react';
import { HeatDto, TeamDto } from '../../api/apis';
import { fetchNotStartedHeats, fetchStartedHeats } from '../../api/apis';
import HeatList from './HeatList/HeatList';
import TeamSearch from './TeamSearch/TeamSearch';

const RaceManagement: React.FC = () => {
  const [notStartedHeats, setNotStartedHeats] = useState<HeatDto[]>([]);
  const [startedHeats, setStartedHeats] = useState<HeatDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refreshHeats = async () => {
    try {
      setIsLoading(true);
      const [notStarted, started] = await Promise.all([
        fetchNotStartedHeats(),
        fetchStartedHeats()
      ]);
      setNotStartedHeats(notStarted);
      setStartedHeats(started);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load heats');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshHeats();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left side - Heat Management */}
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">Not Started Heats</h2>
            <HeatList heats={notStartedHeats} type="not-started" onHeatStarted={refreshHeats} />
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">Started Heats</h2>
            <HeatList heats={startedHeats} type="started" onHeatStarted={refreshHeats} />
          </div>
        </div>

        {/* Right side - Team Search */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Finish Race Management</h2>
          <TeamSearch />
        </div>
      </div>
    </div>
  );
};

export default RaceManagement; 